/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { resetPasswordWithValidation } from 'state/actions/auth_status';
import { displayMessage } from '@insticator/insticator-ui'; // iui-state
import { displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui'; // iui-utils
// component
import ResetPassword from 'pages/auth/resetpassword/resetpassword';



/* ========== ~~~~~~~~~~ AUTH RESET PASSWORD ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ authStatus }) => ({
    fields: authStatus.resetpassword.fields,
    savingData: authStatus.resetpassword.savingData
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    displayMessage: message => dispatch(displayMessage(message)),
    resetPassword: (fields, formData, successAction, failAction) => dispatch(resetPasswordWithValidation(fields, formData, successAction, failAction)),
    displayErrorMessage: errorMessage => dispatch(displayErrorMessage(errorMessage)),
    displaySuccessMessage: successMessage => dispatch(displaySuccessMessage(successMessage))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPassword);
